import { useCallback, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { QueryDropdown } from 'basic-components';
import { DropdownService } from 'primary-components';

import getApiConfig from 'api/ApiConfig';
import properties from 'resources/constants/properties.json';

import { useQueryClient } from '@tanstack/react-query';

const EMPTY_ARRAY = [];
const ALL = { label: "All", value: "*" }
const EMPTY_OBJ = {};

const ValueDropdown = ({ filterKey = undefined, filterMetadataObj = EMPTY_OBJ, filterSymbolObj = EMPTY_OBJ, groupName = undefined, isMetadata = false, isMulti = false, onFinishPickingValue, setFilterValue, valueRef = EMPTY_OBJ, menuPortalTarget = undefined, ...props }) => {
  const dispatch = useDispatch(),
        queryClient = useQueryClient(),
        getApiConfigLocal = useCallback(() => dispatch(getApiConfig()), [dispatch]),
        [symbolValueQuery, setSymbolValueQuery] = useState(),
        { fetchNextPage: fetchMoreSymbolValues, isFetching: isFetchingSymbolValues, isFetchingNextPage: isFetchingNextPageSymbolValues, data: SymbolValuesRaw = EMPTY_ARRAY } = DropdownService.useQuerySymbolValues({
          queryClient,
          input: symbolValueQuery,
          key: filterKey,
          groupName,
          useEs: properties.useEsSymbolListing === "true",
          getApiConfig: getApiConfigLocal,
          ...(isMetadata ? {} : { symbols: filterSymbolObj }),
          metadata: true,
          metadatas: filterMetadataObj,
          enabled: !!groupName && !!filterKey,
          size: 20
        }),
        symbolValues = useMemo(() => [ALL].concat(SymbolValuesRaw), [SymbolValuesRaw])

  return (
    <QueryDropdown
        {...props}
        disabled={!filterKey || !groupName}
        fetchNextPage={fetchMoreSymbolValues}
        isFetching={isFetchingSymbolValues || isFetchingNextPageSymbolValues}
        key={'value'+groupName}
        menuPlacement="bottom"
        menuPortalTarget={menuPortalTarget || document.body}
        multi={isMulti}
        name="symbolValue"
        noError
        onBlur={onFinishPickingValue}
        onChange={setFilterValue}
        onInputChange={setSymbolValueQuery}
        options={symbolValues}
        placeholder="Choose value"
        ref={valueRef}
        required={false}
        validators={undefined}
    />
  )
}

ValueDropdown.propTypes = {
  filterKey: PropTypes.string,
  filterMetadataObj: PropTypes.object,
  filterSymbolObj: PropTypes.object,
  groupName: PropTypes.string,
  isMetadata: PropTypes.bool,
  isMulti: PropTypes.bool,
  menuPortalTarget: PropTypes.any,
  onFinishPickingValue: PropTypes.func.isRequired,
  setFilterValue: PropTypes.func.isRequired,
  valueRef: PropTypes.any
}

export default ValueDropdown;